export default {
  name: {
    label: "Name",
    required: true,
    section: "address",
    info: "Tragen Sie hier den offziellen Namen Ihres Museums ein."
  },
  "address.street": {
    label: "Straße, Hausnr.",
    required: true,
    type: "text",
    section: "address",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier den vollständig ausgeschriebenen Straßennamen ein (ohne Abkürzungen, z. B. Adolf-Wächter-Straße) sowie Ihre Hausnummer. Bei mehreren Hausnummern mit Bindestrich (z. B. 4-10)."
  },
  "address.number": {
    label: "Hausnummer",
    type: "text",
    section: "address"
  },
  "address.zip": {
    label: "PLZ, Ort",
    type: "text",
    section: "address",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier die PLZ und den Ort Ihres Museums ein. Bei einem Ortsteil ggf. mit Bindestrich (z. B. Kronach-Neuses)."
  },
  "address.location": {
    label: "Ort",
    type: "text",
    section: "address"
  },
  "address.region": {
    label: "Landkreis",
    section: "address",
    info: "Bitte wählen Sie aus dem Dropdown-Menü Ihren Landkreis aus."
  },
  "address.latitude": {
    label: "Koordinaten",
    section: "address",
    // eslint-disable-next-line max-len
    info:
      "Die Koordinaten für die Landkarte werden automatisch auf Basis Ihrer eingegebenen Adresse vom System ermittelt. Sollte der Standort Ihres Museums auf der Karte falsch dargestellt werden, müssten die Geokoordinaten ggf. hier angepasst werden. Bitte wenden Sie sich bei Fragen an Ihren MUSbi-Administrator. "
  },
  "address.longitude": {
    label: "Koordinaten",
    section: "address"
  },

  phone: {
    type: "tel",
    label: "Telefon",
    section: "information",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier die Telefonnummer des Museums ein, unter der Buchungen direkt vorgenommen werden können. Bitte beachten Sie dabei die Formatvorgaben <i>Vorwahl Leerzeichen Nummer Bindestrich Nebenstelle</i> (z. B. 0921 7846-1430)."
  },
  fax: {
    type: "tel",
    label: "Fax",
    section: "information",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier die Faxnummer des Museums ein, unter der Buchungen vorgenommen werden können. Bitte beachten Sie dabei die Formatvorgaben <i>Vorwahl Leerzeichen Nummer Bindestrich Nebenstelle</i> (z. B. 0921 7846-91430)."
  },
  website: {
    type: "url",
    label: "Website",
    section: "information",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier die gültige Internetadresse Ihres Museums ein. Bitte beachten Sie, dass http:// oder https:// vorangestellt werden muss (z. B. https://www.bezirk-oberfranken.de)."
  },
  email: {
    type: "email",
    label: "E-Mail",
    section: "information",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier die E-Mail-Adresse Ihres Museums ein, unter der Buchungen vorgenommen werden können."
  },
  description: {
    label: "Beschreibung",
    required: true,
    section: "information",
    // eslint-disable-next-line max-len
    info:
      'Formulieren Sie hier einen kurzen Text, der Ihr Museum näher beschreibt und auf Besonderheiten hinweist. Gehen Sie nach der folgenden Struktur: <ul class="list-styled"><li>Museumsgeschichte, </li><li>Gebäude, </li><li>Sammlung, </li><li>Alleinstellungsmerkmal.</li></ul> Inkl. Leerzeichen sollte er zwischen 100 und 1000 Zeichen umfassen. Verwenden Sie aussagekräftige Schlagwörter, so dass der Eintrag auch für Nutzer, die über Suchmaschinen recherchieren, auffindbar ist'
  },

  openingHours: {
    label: "Öffnungszeiten",
    section: "visit",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier die Öffnungszeiten des Museums ein. Bitte beachten Sie dabei das vorgegebene Format: <br /><i>Wochentage</i> ausschreiben (z. B. Montag); Zeiträume mit Bindestrich (z. B. Montag - Mittwoch); <br /><i>Einzelne Wochentage</i> durch Komma getrennt (z. B. Montag, Dienstag, Freitag) <br /><i>Uhrzeiten</i> mit Doppelpunkt (z. B. 9:30 - 12:30 Uhr); <br />Bei <i>Saisonöffnungszeiten</i> den Monat ausschreiben (z. B. 01. März - 31. Oktober)."
  },
  drivingInstructions: {
    label: "Anfahrt",
    section: "visit",
    info:
      "Falls notwendig, tragen Sie hier eine kurze Beschreibung der Anfahrt zu Ihrem Museum ein."
  },
  entryFeeAdults: {
    label: "Eintritt Erwachsene",
    section: "visit",
    type: "number",
    info:
      "Tragen Sie hier den regulären Eintrittspreis für einen Erwachsenen ein."
  },
  entryFeePupils: {
    label: "Eintritt Schüler",
    section: "visit",
    type: "number",
    info: "Tragen Sie hier den regulären Eintrittspreis für einen Schüler ein.",
    note: "(Pro Schüler)"
  },
  entryFeeGroups: {
    label: "Eintritt Schulklassen",
    section: "visit",
    type: "number",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier – falls vorhanden – den ermäßigten Preis pro Schüler ein, wenn eine ganze Schulklasse zu Besuch ins Museum kommt."
  },
  // resusing field for different purpose
  minGroupSize: {
    label: "Anzahl der kostenfreien Begleitpersonen",
    section: "visit",
    type: "number",
    // eslint-disable-next-line max-len
    info:
      "Tragen Sie hier – falls vorhanden – die Personenanzahl der kostenfreien Begleitpersonen für eine Schulklasse ein."
  },

  equipments: {
    type: "number",
    label: "Ausstattung",
    section: "equipment",
    // eslint-disable-next-line max-len
    info:
      "Wählen Sie zunächst aus dem Dropdown-Menü die verfügbaren Ausstattungselemente in Ihrem Museum aus und tragen Sie die entsprechende Anzahl der Elemente in das Feld daneben ein (z. B. Werkstatt – Anzahl 1).<br/>Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.",
    note: "(und Anzahl)"
  },
  qs: {
    label: "Maßnahmen zur Qualitätssicherung",
    type: "number",
    section: "equipment",
    // eslint-disable-next-line max-len
    info:
      "Wählen Sie aus dem Dropdown-Menü diejenigen Maßnahmen aus, die Ihr Museum zur Qualitätssicherung ergreift. Mit Hilfe des Papierkorbs können Sie falsche Eingaben wieder löschen.",
    note: "(Mehrfachauswahl möglich)"
  },

  links: {
    label: "PDF-Dateien",
    section: "media",
    // eslint-disable-next-line max-len
    info:
      "Durch Anklicken der Schaltfläche „Dateien auswählen“ können Sie PDF-Dateien (z. B. Museumsflyer) zu Ihrem Museum hochladen. Es können mehrere Dateien hochgeladen werden. Bitte achten Sie auf die Dateigröße (max. 1 MB pro Datei) und eine websichere Benennung (keine Leer- oder Sonderzeichen, keine Umlaute). <br/> Bitte geben Sie zu jedem PDF stets eine aussagekräftige Beschreibung mit an, da diese der spätere Anzeigename für das PDF ist. <br/> Für die Wahrung der Urheber- und Persönlichkeitsrechte ist das jeweilige Museum verantwortlich.",
    note: "(Mehrfachauswahl möglich)"
  },
  media: {
    label: "Bilder",
    section: "media",
    // eslint-disable-next-line max-len
    info:
      "Durch Anklicken der Schaltfläche „Dateien auswählen“ können Sie Bilder (JPG, PNG) zu Ihrem Museum hochladen. Es können mehrere Bilder hochgeladen werden. Bitte achten Sie auf die Bildgröße (minimal 1024 x 768 Pixel) sowie die Dateigröße (max. 1 MB) und eine websichere Benennung (keine Leer- oder Sonderzeichen, keine Umlaute). <br /> Bitte geben Sie zu jedem Bild stets eine aussagekräftige Beschreibung mit an. Diese ist dann für den Nutzer sichtbar. Über die Checkbox „als Bannerbild verwenden“ können Sie bei mehreren Bildern das Hauptbild auswählen. Für die Wahrung der Urheber- und Persönlichkeitsrechte ist das jeweilige Museum verantwortlich.",
    note: "(Mehrfachauswahl möglich)"
  }
};



// WEBPACK FOOTER //
// ./src/museum/fieldSpecs.js